import { USER_INITIAL_STATE } from "../constants";

export const getUserFromLocalStorageOrStateLocal = (
	LOCAL_STORAGE_APP_STATE,
	LOCAL_STORAGE_USER,
) => LOCAL_STORAGE_APP_STATE[LOCAL_STORAGE_USER] || { USER_INITIAL_STATE };
